module.exports = __webpack_public_path__ + "res/ic_reward_medal.46f7aa5a952c56da95806e137e99eb34.png";